import script from "./FileSetField.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileSetField.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QField});
